/** Settings › Appearance: Dark (default) · Light · Match system. */
import { useState } from 'react'
import { applyTheme, storedTheme, THEME_CHOICES } from '../../lib/theme.js'
import { Section } from './shared.js'

export function AppearanceSection() {
  return <Appearance />
}

function Appearance() {
  const [theme, setTheme] = useState(storedTheme)
  return (
    <Section id="appearance" title="Appearance">
      <div className="choice st-choice" role="radiogroup" aria-label="Theme">
        {THEME_CHOICES.map(({ id, label }) => (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={theme === id}
            onClick={() => {
              setTheme(id)
              applyTheme(id)
            }}
          >
            {label}
          </button>
        ))}
      </div>
    </Section>
  )
}
